var _defs, _path, _path2, _circle, _circle2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.09 52.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,18.89v0H17.1v0l-.33,0a16.78,16.78,0,1,0,12.47,28h2.61A16.76,16.76,0,1,0,45,18.89ZM44.31,48.4a12.8,12.8,0,0,1-9.49-4.25,4,4,0,0,0-3-1.33H29.24a4,4,0,0,0-3,1.33,12.77,12.77,0,1,1-9.57-21.3l.34,0h.07l.36,0h27a2.22,2.22,0,0,0,.37,0,12.77,12.77,0,0,1-.56,25.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.1,33.62H18.92V29.45a2,2,0,1,0-4,0v4.17H10.74a2,2,0,0,0,0,4h4.18V41.8a2,2,0,1,0,4,0V37.62H23.1a2,2,0,0,0,0-4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.04,
    cy: 35.63,
    r: 2.33
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.1,
    cy: 35.63,
    r: 2.33
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.07,28.27A2.33,2.33,0,1,0,46.4,30.6,2.33,2.33,0,0,0,44.07,28.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.07,38.33a2.33,2.33,0,1,0,2.33,2.32A2.32,2.32,0,0,0,44.07,38.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.35,17.09h.2a2,2,0,0,0,2-1.81c0-.48.61-4.69,4.79-4.69h8a10.16,10.16,0,0,0,7-2.39A8.14,8.14,0,0,0,54.74,2a2,2,0,0,0-4,0,4.3,4.3,0,0,1-1.16,3.28A6.34,6.34,0,0,1,45.45,6.6H37.32C31,6.6,28.81,12,28.55,14.92A2,2,0,0,0,30.35,17.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.51f287cf.svg";
export { ForwardRef as ReactComponent };